import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import { AdminKeyUpsell } from '@confluence/change-edition/entry-points/AdminKeyUpsell.tsx';
import { Link } from '@confluence/route-manager/entry-points/Link.ts';

import { AdminKeyMessageCard, type AdminKeyMessageCardProps } from './AdminKeyMessageCard.tsx';

const body = (
	<FormattedMessage
		id="super-admin.upsell.message"
		defaultMessage="{canBeSuperAdmins} with Premium can use admin key to get temporary access to restricted content so they can troubleshoot and fix problems fast."
		description="Message to the user about super admin bypass restrictions"
		tagName="p"
		values={{
			canBeSuperAdmins: (
				<Link target="_blank" to="/admin/users?role=site%2Fadmin">
					<FormattedMessage
						id="super-admin.upsell.message.can-be-super-admins"
						defaultMessage="Site admins"
						description="The human-readable user-facing description of users who canBeSuperAdmin (i.e. Site admins)"
					/>
				</Link>
			),
		}}
	/>
);

const title = (
	<FormattedMessage
		id="super-admin.upsell.title"
		defaultMessage="Upgrade for admin key"
		description="Title for the Super Admin upsell section"
	/>
);

export type AdminKeyUpSellProps = Pick<AdminKeyMessageCardProps, 'type'>;

export const AdminKeyUpSell = ({ type }: AdminKeyUpSellProps) => (
	<AdminKeyMessageCard eventName="adminKeyUpsellScreen" type={type}>
		<AdminKeyUpsell body={body} title={title} />
	</AdminKeyMessageCard>
);
